import { useMemo } from 'react';
import { notification } from 'antd';
import type { ArgsProps, NotificationInstance } from 'antd/es/notification/interface';
import './Notification.css';

export type WxbNotificationType = 'success' | 'info' | 'warning' | 'error';

export interface WxbNotificationConfig {
  key?: ArgsProps['key'];
  title: ArgsProps['message'];
  description?: ArgsProps['description'];
  duration?: ArgsProps['duration'];
  action?: ArgsProps['btn'];
  placement?: ArgsProps['placement'];
}

const toArgs = (config: WxbNotificationConfig): ArgsProps => ({
  key: config.key,
  message: config.title,
  description: config.description,
  duration: config.duration,
  btn: config.action,
  placement: config.placement,
  className: 'wxb-notification',
});

const createWxbNotification = (api: NotificationInstance) => ({
  open: (config: WxbNotificationConfig) => api.open(toArgs(config)),
  success: (config: WxbNotificationConfig) => api.success(toArgs(config)),
  info: (config: WxbNotificationConfig) => api.info(toArgs(config)),
  warning: (config: WxbNotificationConfig) => api.warning(toArgs(config)),
  error: (config: WxbNotificationConfig) => api.error(toArgs(config)),
  close: (key: ArgsProps['key']) => api.destroy(key),
  destroy: () => api.destroy(),
});

export type WxbNotificationApi = ReturnType<typeof createWxbNotification>;

export const wxbNotification: WxbNotificationApi = createWxbNotification(notification);

export const useWxbNotification = () => {
  const [api, contextHolder] = notification.useNotification();
  const notify = useMemo(() => createWxbNotification(api), [api]);
  return [notify, contextHolder] as const;
};

